import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TypeChecker } from '../../../shared/classes/type-checker';
import { CalendarModule } from 'primeng/calendar';
import { BaseControl } from '../../../shared/classes/form-base-controls';

@Component({
  selector: 'app-calendar-control',
  standalone: true,
  imports: [
    CommonModule, ReactiveFormsModule,
    CalendarModule
  ],
  template:`
    <div [formGroup]="formGroup" *ngIf="typeChecker.isCalendar(control)" class="w-full">
        <p-calendar [formControlName]="control.name" showIcon="true" [dateFormat]="control.dateFormat"
                    appendTo="body"  class="w-full" styleClass="w-full" [attr.aria-describedby]="control.name + '-help'"></p-calendar>
    </div>
  `,
  styles: `
    :host {
      display: contents;
    }
  `
})
export class CalendarControlComponent {
  @Input() control !: BaseControl<any>;
  @Input() formGroup !: FormGroup;

  typeChecker = TypeChecker;
}
